<y42-container-with-side-detail-view>
  <y42-job-list-view-content [id]="id"></y42-job-list-view-content>
  <ng-template y42SideDetailView>
    <y42-job-list-view-details></y42-job-list-view-details>
  </ng-template>
</y42-container-with-side-detail-view>
